// 접속 로그 — 페이지네이션 (more 버튼).

import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/admin';
import type { AccessLog } from '../api/types';
import { Spinner } from '../components/Spinner';
import { formatDateTime } from '../utils/format';

const PAGE_SIZE = 50;

export default function AccessLogs() {
  const [items, setItems] = useState<AccessLog[]>([]);
  const [before, setBefore] = useState<number | undefined>(undefined);
  const [done, setDone] = useState(false);

  const { isLoading, refetch, isFetching } = useQuery({
    queryKey: ['admin', 'accessLogs', 'page', before],
    queryFn: async () => {
      const page = await adminApi.accessLogs(PAGE_SIZE, before);
      setItems((prev) => [...prev, ...page.items]);
      if (page.nextBefore === null) setDone(true);
      else setBefore(page.nextBefore);
      return page;
    },
  });

  const onMore = () => { void refetch(); };

  return (
    <div className="stack">
      <h2>접속 로그</h2>
      <div className="logs-wrap">
        <table className="logs">
          <thead>
            <tr><th>시각</th><th>IP</th><th>결과</th><th>사유</th><th>UA</th></tr>
          </thead>
          <tbody>
            {items.map((l) => (
              <tr key={l.id} className={l.success ? 'ok' : 'fail'}>
                <td>{formatDateTime(l.createdAt)}</td>
                <td><code>{l.ip}</code></td>
                <td>{l.success ? '성공' : '실패'}</td>
                <td>{l.failedReason ?? ''}</td>
                <td className="ua">{l.userAgent ?? ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {(isLoading || isFetching) && <Spinner />}
      {!done && !isLoading && (
        <button type="button" className="btn btn--ghost" onClick={onMore} disabled={isFetching}>
          더 보기
        </button>
      )}
      {done && <p className="muted">더 이상 항목이 없습니다.</p>}
    </div>
  );
}
